import React from 'react'
import AdditionalComponent from 'src/Libs/shop/components/SystemConfiguration/AdditionalComponent'
import { useShopNormalAdditionalComponent } from '../hooks/use-shop-normal-additional-component'

/*
 * Wrapper for Additional Component step connecting hook data to the view
 */
const NormalAdditionalComponent: React.FC = () => {
  const {
    title,
    categories,
    isLoading,
    onBack,
    currentTransformers,
    availableSmartMeters,
    showPowerMeterSection,
    powerMeterTabLabel,
    powerMeterInitialId,
    onMoreInfo,
    isProductSelected,
    getSelectedProduct,
    onDecreaseProductQuantity,
    onIncreaseProductQuantity,
    onAddProductToCart,
    onRemoveProductFromCart,
  } = useShopNormalAdditionalComponent()

  return (
    <AdditionalComponent
      title={title}
      categories={categories}
      isLoading={isLoading}
      onBack={onBack}
      currentTransformers={currentTransformers}
      availableSmartMeters={availableSmartMeters}
      showPowerMeterSection={showPowerMeterSection}
      powerMeterTabLabel={powerMeterTabLabel}
      powerMeterInitialId={powerMeterInitialId}
      onMoreInfo={onMoreInfo}
      isProductSelected={isProductSelected}
      getSelectedProduct={getSelectedProduct}
      onDecreaseProductQuantity={onDecreaseProductQuantity}
      onIncreaseProductQuantity={onIncreaseProductQuantity}
      onAddProductToCart={onAddProductToCart}
      onRemoveProductFromCart={onRemoveProductFromCart}
    />
  )
}

export default NormalAdditionalComponent
